<template>
  <StatisticsHeader>
    <StatisticsPanel :load="load" v-slot="{ data }">
      <OverviewStats :data="data" />
    </StatisticsPanel>
  </StatisticsHeader>
</template>

<script>
import StatisticsHeader from "@/statistics/components/StatisticsHeader.vue";
import StatisticsPanel from "@/statistics/components/StatisticsPanel.vue";
import OverviewStats from "@/statistics/components/stats/OverviewStats.vue";
import {StatisticsController} from "@/statistics/controllers/StatisticsController";

export default {
  name: 'StatisticsOverviewView',
  components: {StatisticsHeader, StatisticsPanel, OverviewStats},
  methods: {
    load: urlParams => StatisticsController.getOverview(urlParams),
  },
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

h1
  color: THEME_COLOR_PRIMARY
  span
    color: THEME_COLOR_PRIMARY_FADDED
</style>
